<template>
  <div>
    <el-dialog
      v-model="teacherQrcodeShow"
      title="Tips"
      width="500"
      :show-close="false"
      :align-center="true"
      :close-on-click-modal="false"
    >
      <template #header>
        <div class="header">联系TA</div>
        <div class="close_icon cursor_pointer">
          <el-icon :size="20" @click="closePopup">
            <CloseBold />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <qrcode-vue class="mt-15" :value="qrcodeValue" :size="130"></qrcode-vue>
        <div class="mt-15">伴学师二维码</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
export default {
  name: "GjkcTeacherQrcode",
  components: {
    QrcodeVue,
  },

  data() {
    return {
      teacherQrcodeShow: false,
      qrcodeValue: "",
    };
  },

  mounted() {},

  methods: {
    closePopup() {
      this.teacherQrcodeShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  width: 298px;
  height: 269px;
  background: #f5f6f8;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 0;
}

:deep(.el-dialog__header) {
  position: relative;
//   padding: 0 20px;
  box-sizing: border-box;
  text-align: start;
}

.header {
  //   text-align: center;
  //   font-weight: bold;
  font-size: 20px;
  color: #333333;
  line-height: 60px;
  font-weight: 600;
  border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #333333;
}

.dialog_content {
    text-align: center;
}
</style>
